import { firestore } from '../../utils/firebase'

export const RECEIVED_PRIORITY_RENTALS = 'RECEIVED_PRIORITY_RENTALS'

const propertiesRef = firestore.collection('properties_for_review')
const propertySettingsRef = firestore.collection('property_settings')

export const receivedPriorityRentals = priorityRentals => {
  return {
    type: RECEIVED_PRIORITY_RENTALS,
    priorityRentals
  }
}

export const fetchPriorityRentals = () => {
  return async dispatch => {
    const priorityRentals = []

    const priorityRentalsDoc = await propertySettingsRef
      .doc('priority_rentals')
      .get()

    if (priorityRentalsDoc.exists) {
      const propertyIds = Object.keys(priorityRentalsDoc.data())

      await Promise.all(propertyIds.map(async propertyId => {
        const propertyDoc = await propertiesRef
          .doc(propertyId)
          .get()

        if (propertyDoc.exists) {
          priorityRentals.push(propertyDoc.data())
        }
      }))
    }

    dispatch(receivedPriorityRentals(priorityRentals))
  }
}
